export function capitalize(string) {
    return string
        .toLowerCase()
        .split(/(-|\s)/)
        .map((part) => (part === "-" || part === " " ? part : part.charAt(0).toUpperCase() + part.slice(1)))
        .join("");
}
